

@if (state$ | async; as state) {
<div
  class="absolute left-0 right-0 mx-auto h-screen w-screen flex flex-col justify-center items-center  overscroll-none backdrop-br bg-black/80">

  <div class="max-w-md overflow-hidden shadow-lg frosty m-4 text-center px-4 md:px-0">

    <div class="px-6 py-5">
      <div class="font-bold text-xl mb-2">{{'SystemAdmin.Components.UpdateModal.Title' | translate}}</div>
      
      <p class="text-gray-700 text-base">
        {{'SystemAdmin.Components.UpdateModal.Description' | translate}}
      </p>

      <div class="text-center mt-4">
        @if (state.phase === 'countdown') {
        <span class="text-7xl font-bold text-red-500">
          {{ state.currentCountdown }}
        </span>

        } @else if (state.phase === 'initiating') {
        <span class="text-lg font-bold text-red-500 mt-4 block">
          {{'SystemAdmin.Components.UpdateModal.UpdateStarting' | translate}}
        </span>
        }
      </div>

      <div class="update-progress mt-5">
        <div class="update-progress__track">
          <div class="update-progress__bar" [style.width.%]="state.progressPercent"></div>
        </div>
        <div class="update-progress__meta">
          {{ state.progressPercent }}%
        </div>
      </div>

      <ul class="update-steps">
        <li *ngFor="let step of steps; let i = index"
            [class.done]="i < state.currentStepIndex"
            [class.active]="i === state.currentStepIndex">
          <span class="update-steps__dot"></span>
          <span class="update-steps__label">{{ step | translate }}</span>
        </li>
      </ul>

      <div class="update-actions">
        <button type="button" class="update-actions__defer" (click)="deferUpdate()">
          {{ 'SystemAdmin.Components.UpdateModal.Defer' | translate }}
        </button>
      </div>

    </div>

  </div>

</div>
<div class="fireworks-container"></div>
}
